import { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";

const useUser = () => {
  const { instance, accounts, inProgress } = useMsal();
  const [name, setName] = useState('');
  const [username, setUsername] = useState('');
  const [roles, setRoles] = useState<string[]>([]);

  useEffect(() => {
    if (Array.isArray(accounts) && accounts.length !== 0) {
      setName(accounts[0].name || accounts[0].username || '');
      setUsername(accounts[0].username);

      const claims = accounts[0]?.idTokenClaims as any;
      if (claims) {
        if (Array.isArray(claims.roles)) {
          setRoles(claims.roles);
        } else if (typeof claims.role === 'string') {
          setRoles([claims.role]);
        } else {
          setRoles([]);
        }
      } else {
        setRoles([]);
      }
    }
  }, [inProgress, accounts, instance]);

  return {
    inProgress,
    name,
    username,
    roles
  }
}

export default useUser;